<div>
  <div>
    <mat-form-field>
      <mat-label>Slug</mat-label>
      <input matInput [(ngModel)]="slug" required />
    </mat-form-field>
  </div>

  @if (supportAddItem) {
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="addNewItem()">
      <mat-icon>rule</mat-icon>
      Add new Search Filter Item
    </button>
  }

  @if (supportAddItem) {
    <div
      cdkDropList
      class="item-container"
      (cdkDropListDropped)="searchItemDropped($event)">
      @for (item of items; track item; let i = $index) {
        <div
          cdkDrag
          cdkDragLockAxis="y"
          class="item"
          >
          <mat-icon
            [matBadge]="item.order"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="before"
            cdkDragHandle
            class="handle"
            matTooltip="Drag here to order the items"
            >reorder</mat-icon
            >
            <gymfinder-search-filter-item
              [item]="item"
              [availableFilters]="availableFilters"
              (itemChange)="onItemChanged($event, i)"
              (itemRemove)="onItemRemove(i)"
              class="item-content">
            </gymfinder-search-filter-item>
          </div>
        }
      </div>
    }
  </div>
